import * as Types from '@/store/mutation-types'
import { set_one, set_many, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '@/store/mutation-mixins'
import { set } from "@/store/mutation-mixins";

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Types.SET_COUNTS]: set({ to: 'counts' }),
    [Types.SET_MANY]: set_many({ to: 'entities' }),
    [Types.SET_ONE]: set_one({ to: 'entities' }),

}
